import React from 'react';
import { AGENT_PHOTO_URL, agent } from '../../data/content';
type AgentPortraitProps = {
  size?: 'md' | 'lg';
};
export function AgentPortrait({
  size = 'md'
}: AgentPortraitProps) {
  const dimensions = size === 'lg' ? 'h-32 w-32 md:h-36 md:w-36' : 'h-20 w-20';
  return <img src={AGENT_PHOTO_URL} alt={agent.name} className={`${dimensions} shrink-0 rounded-full object-cover object-center ring-2 ring-brand-gold/50 ring-offset-4 ring-offset-ink-card`} data-id="element-175" data-mp="2loops9ewwer9" />;
}